import { SearchOutlined } from '@mui/icons-material'
import { AppBar, Grid, IconButton, InputAdornment, Menu, Slide, TextField, Toolbar, Typography } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import User from './User'

interface AppHeaderProps {
  isMobile: boolean
  trigger: boolean
}

// This is called AppHeader as to not be confused with MUI's AppBar.
export default function AppHeader({ isMobile, trigger }: AppHeaderProps) {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)
  const [searchValue, setSearchValue] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const navigate = useNavigate()

  const handleSearchSubmit = async () => {
    if (!searchValue) {
      setErrorMessage('Please enter a search value')
      return
    }

    try {
      const response = await fetch(`/api/vehicles/search?q=${encodeURIComponent(searchValue)}`)
      if (response.ok) {
        const data = await response.json()
        const vehicle = data.value
        if (vehicle && vehicle.vehicleGuid) {
          navigate(`/vehicles/${vehicle.vehicleGuid}`)
          setErrorMessage('')
        } else {
          setErrorMessage('No results found')
        }
      } else {
        setErrorMessage('No results found')
      }
    } catch (error) {
      setErrorMessage('An error occurred while searching for the vehicle')
    }
  }

  return (
    <>
      <Slide appear={false} direction='down' in={!trigger}>
        <AppBar position='fixed' sx={{ backgroundColor: '#152B54', paddingLeft: isMobile ? '0px' : '245px' }}>
          <Toolbar>
            <Grid container spacing={1} alignItems='center' justifyContent='space-between'>
              <Grid item xs={6} sm='auto' container>
                <Grid item>
                  <TextField
                    data-search
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton onClick={handleSearchSubmit}>
                            <SearchOutlined fontSize='small' />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    label='VIN, Last 6 of VIN, or Importer Stock #'
                    variant='outlined'
                    name='search'
                    size='small'
                    type='search'
                    InputLabelProps={{ shrink: true }}
                    value={searchValue}
                    onChange={e => setSearchValue(e.target.value)}
                    onKeyPress={e => {
                      if (e.key === 'Enter') {
                        handleSearchSubmit()
                      }
                    }}
                    sx={{
                      '& label': {
                        color: 'white'
                      },
                      '& label.Mui-focused': {
                        color: 'white'
                      },
                      '& .MuiInput-underline:after': {
                        borderBottomColor: 'white'
                      },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'white'
                        },
                        '&:hover fieldset': {
                          borderColor: 'white',
                          borderWidth: 2
                        },
                        '& .Mui-focused fieldset': {
                          borderColor: 'white'
                        }
                      },
                      '& .MuiInputAdornment-root': {
                        color: '#fff'
                      },
                      '& .MuiInputBase-input': {
                        color: '#fff'
                      },
                      '& .MuiButtonBase-root': {
                        color: '#fff'
                      }
                    }}
                  />
                </Grid>

                {errorMessage && (
                  <Grid item>
                    <Typography color='error' fontWeight='bold' variant='body1'>
                      {errorMessage}
                    </Typography>
                  </Grid>
                )}
              </Grid>

              <Grid item xs={6} sm='auto'>
                <User />
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </Slide>

      <Menu
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null)
        }}
        open={Boolean(anchorEl)}
      ></Menu>
    </>
  )
}
